import { render, staticRenderFns } from "./ItemLayout.vue?vue&type=template&id=87f946ea&scoped=true"
import script from "./ItemLayout.vue?vue&type=script&lang=js"
export * from "./ItemLayout.vue?vue&type=script&lang=js"
import style0 from "./ItemLayout.vue?vue&type=style&index=0&id=87f946ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f946ea",
  null
  
)

export default component.exports